export const hasAlready = (
  _array: unknown[],
  _key: string,
  _value: unknown,
): boolean => {
  const _filtered_array = _array?.filter((item) => item[_key] === _value);
  return _filtered_array?.length ? true : false;
};
